import { useState } from 'react'
import { Compass } from 'lucide-react'

import Tour from '@core/layout/tour/Tour'
import { marcarTourVisto, tourJaVisto } from '@core/layout/tour/steps'

/** Segura o guia de dois minutos e o convite para o abrir.
 *
 *  O convite aparece uma vez só, a quem nunca o viu neste browser, e
 *  fica num canto em vez de se impor por cima do ecrã: quem chega para
 *  abrir um IFC deve poder abri-lo sem primeiro despachar um diálogo.
 *
 *  O guia também se abre de propósito, pelo botão da bússola ao lado
 *  dos atalhos de teclado, para quem o dispensou e se arrependeu. */
export default function TourHost() {
  const [aberto, setAberto] = useState(false)
  const [convite, setConvite] = useState(() => !tourJaVisto())

  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        title="Guia de dois minutos"
        className="flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] text-[var(--color-text-muted)] hover:bg-[var(--color-bg)] hover:text-[var(--color-text)]"
      >
        <Compass size={14} />
      </button>

      {convite && !aberto && (
        <div className="fixed right-4 bottom-10 z-[1050] w-64 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] p-3 shadow-xl">
          <p className="text-xs text-[var(--color-text)]">
            Primeira vez por aqui? Há um guia de dois minutos com o
            essencial.
          </p>
          <div className="mt-2 flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={() => {
                marcarTourVisto()
                setConvite(false)
              }}
              className="rounded px-2 py-1 text-[11px] text-[var(--color-text-dim)] hover:text-[var(--color-text)]"
            >
              Agora não
            </button>
            <button
              type="button"
              onClick={() => {
                setConvite(false)
                setAberto(true)
              }}
              className="rounded border border-[var(--color-accent-border)] bg-[var(--color-accent-bg)] px-3 py-1 text-[11px] font-medium text-[var(--color-text)] hover:bg-[var(--color-accent-hover)]"
            >
              Ver o guia
            </button>
          </div>
        </div>
      )}

      {aberto && (
        <Tour
          aoFechar={() => {
            setAberto(false)
            setConvite(false)
          }}
        />
      )}
    </>
  )
}
